import MDBox from "components/MDBox";

import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import right from "../../../assets/images/right.png"
import { SHADOW, SIGNAL, GLASS } from "../theme/uiTokens";

export default function FloatingTopButtons({
  onSearchClick,
  onLogoutClick,
  demoName = "Demo",
  darkMode,
  onProfileClick
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const surface = darkMode ? GLASS.dark : GLASS.light;

  const account = useSelector(
    (state) => state.account.data?.accountModel?.account
  );
  const fullName = account
    ? `${account.firstName || ""} ${account.lastName || ""}`.trim()
    : "";

  const orgName = localStorage.getItem("orgName");

 const handleLogout = async () => {
  const token = localStorage.getItem("token");

  try {
    if (token) {
      await axios.get("https://v3.dhundhoo.com/auth/signout", {
        headers: {
          "x-dhundhoo-session": token,
        },
      });
    }
  } catch (error) {
    console.error("Logout API failed, clearing token anyway");
  } finally {
    // API fail ho ya success — token clear hoga hi
    localStorage.removeItem("token");
    navigate("/authentication/sign-in");
  }
};

  const handleProfileClick = () => {
    navigate("/profile");
  };
  return (
    <MDBox
      sx={{
        position: "absolute",
        top: { xs: 12, sm: 20 },
        left: { xs: 12, sm: 20 },
        right: { xs: 12, sm: 20 },
        zIndex: 2000,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        pointerEvents: "none",
      }}
    >

      {/* 🔍 Search Button — glass disc with a signal-gradient ring and a live pulse */}
      <MDBox
        sx={{
          position: "relative",
          width: { xs: 42, sm: 46, md: 50 },
          height: { xs: 42, sm: 46, md: 50 },
          borderRadius: "50%",
          padding: "2px",
          background: SIGNAL.gradient,
          boxShadow: SHADOW.floating,
          cursor: "pointer",
          pointerEvents: "auto",
          transition: "transform 0.18s ease, box-shadow 0.18s ease",
          "&:hover": {
            transform: "translateY(-1px) scale(1.04)",
            boxShadow: `0 6px 20px rgba(139, 92, 246, 0.45)`,
          },
        }}
        onClick={onSearchClick}
      >
        <MDBox
          sx={{
            width: "100%",
            height: "100%",
            borderRadius: "50%",
            background: surface.panel,
            backdropFilter: "blur(10px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src={right}
            alt="right-arrow"
            style={{
              width: isMobile ? "16px" : "20px",
              height: isMobile ? "16px" : "20px",
              cursor: "pointer",
              filter: darkMode ? "invert(1)" : "none",
            }}
          />
        </MDBox>

        {/* live indicator dot */}
        <MDBox
          sx={{
            position: "absolute",
            top: -1,
            right: -1,
            width: 11,
            height: 11,
            borderRadius: "50%",
            background: "#10B981",
            border: `2px solid ${darkMode ? "#151b2e" : "#ffffff"}`,
            boxShadow: "0 0 0 rgba(16, 185, 129, 0.6)",
            animation: "signalPulse 2s infinite",
            "@keyframes signalPulse": {
              "0%": { boxShadow: "0 0 0 0 rgba(16, 185, 129, 0.55)" },
              "70%": { boxShadow: "0 0 0 6px rgba(16, 185, 129, 0)" },
              "100%": { boxShadow: "0 0 0 0 rgba(16, 185, 129, 0)" },
            },
          }}
        />
      </MDBox>

      {/* 🧑 Org name */}
      {/* {fullName && (
        <MDBox
          sx={{
            padding: "8px 16px",
            borderRadius: "20px",
            backgroundColor: darkMode ? "#1f283e" : "rgba(255,255,255,0.85)",
            fontSize: isMobile ? "12px" : "14px",
            fontWeight: 600,
            boxShadow: "0 3px 12px rgba(0,0,0,0.15)",
            backdropFilter: "blur(6px)",
          }}
        >
          {orgName}
        </MDBox>
      )} */}

    </MDBox>
  );
}
